import { Component, Input } from '@angular/core';
import * as d3 from 'd3';

@Component({
  selector: 'app-pie-chart-portfolio',
  template: `
    <figure id="pie-portfolio"></figure>
  `,
  styleUrls: []
})
export class PieChartPortfolioComponent {
  @Input() data: any;
  
  private svg: any;
  width = 250;
  height = 250;
  margin = 20;
  radius: any;

  constructor() { }

  ngOnInit(): void {
    
    this.createSvg();
    this.drawChart(this.data);
  }

  private createSvg(): void {
    const myElement = document.getElementById('portafolioChart');
    if (myElement) {
      this.width = myElement.getBoundingClientRect().width;
      this.height = myElement.getBoundingClientRect().width;
      // console.log('WIDTH => ', this.width);
    }
    this.radius = Math.min(this.width, this.height) / 2 - this.margin;

    this.svg = d3.select("figure#pie-portfolio")
      .append("svg")
      .attr("width", this.width)
      .attr("height", this.height)
      .append("g")
      .attr("transform", "translate(" + this.width / 2 + "," + this.height / 2 + ")");
  }

  private drawChart(datax: any): void {
    // Define the data
    let data: any = [
      { name: "Cartera vencida", value: datax.past_due },
      { name: "Cartera al corriente", value: datax.paid },
    ];
  
    // Define the color scale
    const color = d3.scaleOrdinal()
      .domain(data.map((d: any) => d.name))
      .range(["#D3A913", "#6D6D6D"]);
  
    // Create the pie generator
    const pie = d3.pie()
      .value((d: any) => d.value);
  
    // Prepare the data for the pie chart
    const data_ready = pie(data);
  
    // Draw the arcs with an inner radius for the doughnut chart
    this.svg.selectAll('slices')
      .data(data_ready)
      .enter()
      .append('path')
      .attr('d', d3.arc()
        .innerRadius(this.radius * 0.5) // Inner radius for the doughnut
        .outerRadius(this.radius) // Outer radius
      )
      .attr('fill', (d: any) => color(d.data.name))
      .style("opacity", 0.7);
  
    // Add labels to the chart
    this.svg.selectAll('labels')
      .data(data_ready)
      .enter()
      .append('text')
      .text((d: any) => d.data.name)
      .attr('transform', (d: any) => {
        const pos = d3.arc()
          .innerRadius(this.radius * 0.6) // Adjust label position
          .outerRadius(this.radius * 0.6)
          .centroid(d);
        return `translate(${pos[0]}, ${pos[1]})`;
      })
      .style('text-anchor', 'middle')
      .style('font-size', '12px');
  }
  

  
}
